$(function () {
  var componentSection = $('.salesforceAPIForm');
  var form = componentSection.find('form');
  var url = form.attr('action');
  var submitButton = form.find('[name="submit"]');
  var requiredInputFields = form.find('input[required]');
  var errorMessageTextNoAbo = form.find('.js-errorMessageTextNoAbo');

  $('body').click(function (e) {
    requiredInputFields.css('border', '');
  });

  var responseParagraph = componentSection.find('.response');
  var onFetch = function (callback) {
    var requestUrl = url + '?' + form.serialize();
    var request = {
      type: 'GET',
      url: requestUrl,
      dataType: 'html',
    };
    window.ContentFetcher.fetch(request, callback);
  };
  var callBack = function (data) {
    var text = data.trim();
    var button = $('<button class="responseButton"></button>');
    button.on('click', function () {
      button.remove();
      form.show();
      responseParagraph.hide();
    });
    if (text === 'SUCCESS') {
      button.text(form.data('nextButtonText'));
      responseParagraph.text(form.data('thankYouText')).show();
    } else {
      button.text(form.data('retryText'));
      responseParagraph.text(form.data('errorMessageText')).show();
    }
    componentSection.append(button);
  };
  var validate = function () {
    // fail if one ist not required
    for (let i = 0; i < requiredInputFields.length; i++) {
      var $input = requiredInputFields.eq(i);
      if (!$input.val()) {
        $input.css('border', 'thin solid red');
        return false;
      }
    }

    // fail if none was selected
    return hasOneCheckboxChecked();
  };

  var hasOneCheckboxChecked = function () {
    return form.find('input[type="checkbox"]:checked').length > 0;
  };

  form.find('[type="submit"]').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    errorMessageTextNoAbo.hide();

    var valid = validate();

    if (valid) {
      form.hide();
      responseParagraph.text(form.data('pleaseWaitButtonText')).show();
      onFetch(callBack);
    } else {
      if (!hasOneCheckboxChecked()) {
        errorMessageTextNoAbo.show();
      }
    }
  });
});
